module.exports = __webpack_public_path__ + "static/media/product-feature-1.b662df85.svg";